// angular
//     .module("HeroPRO")
//     .controller("PrimaryInformationController", primaryInformationController);

import './primaryInformation.scss';

/* @ngInject */
export default function PrimaryInformationController($window, HPConfig, FRInformationFactory, LeadFactory, $scope, $stateParams, FundingRequestDatastore, JobFactory, $attrs) {
    const vm = this;

    vm.isInfoCollapsed = ($window.innerWidth < HPConfig.screenSizes.screen_md);
    vm.showCollapseIcon = vm.isInfoCollapsed;
    vm.jobNumberLinkText = '';
    vm.contractorJobs = [];
    vm.primaryData = null;
    vm.recentlyUnhidden = false;
    // vm.proPitchClick = proPitchClick;


    function setJobNumberLinkText(data) {
        if (data !== undefined && data.length !== 0) {
            let firstJobId = data[0].ContractorSystemJobId;

            if (firstJobId.length > 12) {
                firstJobId = `${firstJobId.substring(0, 12)}...`;
            }

            vm.jobNumberLinkText = firstJobId;
        } else {
            vm.jobNumberLinkText = 'Add Number';
        }
    }

    function init() {
        if ($attrs.piInformationType === 'fundingRequest') {
            FRInformationFactory.getFundingRequestInformationPromise().then(() => {
                vm.primaryData = FRInformationFactory.getAppInfo();
                FundingRequestDatastore.setPrimaryInformation(vm.primaryData);
                setJobNumberLinkText(vm.primaryData.ContractorJobs);
            });

            $scope.$watch('primaryInformation.contractorJobs', () => {
                setJobNumberLinkText(vm.contractorJobs);
            }, true);
        } else if ($attrs.piInformationType === 'lead') {
            LeadFactory.getLeadData($stateParams.prequalId).then((leadData) => {
                vm.primaryData = leadData;
                FundingRequestDatastore.setPrimaryInformation(vm.primaryData);
            });
        }
    }


    vm.unhideProject = () => {
        if ($attrs.piInformationType === 'fundingRequest') {
            JobFactory.unhideApplication({ FundingRequestId: vm.primaryData.FundingRequestId }).then(() => {
                vm.primaryData.IsContractorJobHidden = false;
                vm.recentlyUnhidden = true;
            });
        } else if ($attrs.piInformationType === 'lead') {
            JobFactory.unhideLead({ PreQualId: vm.primaryData.PreQualID }).then(() => {
                vm.primaryData.IsContractorJobHidden = false;
                vm.recentlyUnhidden = true;
            });
        }
    };

    init();
}



// WEBPACK FOOTER //
// ./src/app/common/primaryInformation/primaryInformationController.js